// extracted by mini-css-extract-plugin
export default {"wrapper":"styles-module__wrapper--fjOou","notch":"styles-module__notch--i1AeL"};